import { LifeCycles, registerApplication, start } from "single-spa";
import { PMITheme as theme } from './PMITheme'
import { setActiveContentLayout } from './activeRouting';
import { authenticate } from '@pmi/communication-hub';
import { displayVersion } from "./config";
import './styles.ts';

const app = (url: string) => System.import<LifeCycles>(`${url}?t=${window.BUILD_TIME}`);

const registerApps = () => {
  setActiveContentLayout();
  displayVersion();
  
  registerApplication({
    name: "@pmi/intb-dashboard",
    app: () => app(process.env.PMI_INTB_DASHBOARD_SRC_URL),
    activeWhen: ["/dashboard", "/intb",],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/tbcf-dashboard",
    app: () => app(process.env.PMI_TBCF_DASHBOARD_SRC_URL),
    activeWhen: ["/dashboard", "/tbcf"],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/navigation",
    app: () => app(process.env.PMI_NAVIGATION_SRC_URL),
    activeWhen: ["/"],
    customProps: { theme },
  });

  registerApplication({
    name: "@pmi/intb",
    app: () => app(process.env.PMI_INTB_SRC_URL),
    activeWhen: ['intb'],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/tbcf",
    app: () => app(process.env.PMI_TBCF_SRC_URL),
    activeWhen: ['tbcf'],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/alc",
    app: () => app(process.env.PMI_ALC_SRC_URL),
    activeWhen: ["/alc"],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/control-panel",
    app: () => app(process.env.PMI_CONTROL_PANEL_SRC_URL),
    activeWhen: ["/control-panel"],
    customProps: { theme }
  });

  registerApplication({
    name: "@pmi/alarm-modal",
    app: () => app(process.env.PMI_ALARM_MODAL_SRC_URL),
    activeWhen: ["/"],
    customProps: { theme }
  });

  start({
    urlRerouteOnly: false,
  });
}

authenticate(registerApps);


